export const TOC_LINK = "https://nlc.com/terms-of-service/";
export const PRIVACY_POLICY_LINK = "https://nlc.com/privacy-policy/";
export const SIGNUP_LINK = "https://nlc.com/pricing/";
